'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_StoreCartSearch(storeId_$_lo, storeId_$_hi, onlyOpen, pageIndex, pageSize, sort) {
  this.Hv = 0;
  this.Hw = 0;
  this.Da = false;
  this.Db = 0;
  this.Dc = 0;
  this.LI = null;
  this.Hv = storeId_$_lo;
  this.Hw = storeId_$_hi;
  this.Da = onlyOpen;
  this.Db = pageIndex;
  this.Dc = pageSize;
  this.LI = sort;
}
export { $c_Lmealorama_StoreCartSearch as $c_Lmealorama_StoreCartSearch };
$p = $c_Lmealorama_StoreCartSearch.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_StoreCartSearch;
/** @constructor */
function $h_Lmealorama_StoreCartSearch() {
}
export { $h_Lmealorama_StoreCartSearch as $h_Lmealorama_StoreCartSearch };
$h_Lmealorama_StoreCartSearch.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (-68707191));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.Hv, this.Hw)));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.Da ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.Db);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.Dc);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.LI));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 5);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_StoreCartSearch)) {
    if ((((this.Da === x$0.Da) && (this.Db === x$0.Db)) && (this.Dc === x$0.Dc))) {
      var x_$_lo = this.Hv;
      var x_$_hi = this.Hw;
      var $x_2 = x$0;
      var x$1_$_lo = $x_2.Hv;
      var x$1_$_hi = $x_2.Hw;
      var $x_1 = (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$2 = this.LI;
      var x$2$1 = x$0.LI;
      return ((x$2 === null) ? (x$2$1 === null) : x$2.f(x$2$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 5;
});
$p.r = (function() {
  return "StoreCartSearch";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.Hv, this.Hw);
      break;
    }
    case 1: {
      return this.Da;
      break;
    }
    case 2: {
      return this.Db;
      break;
    }
    case 3: {
      return this.Dc;
      break;
    }
    case 4: {
      return this.LI;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_StoreCartSearch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k2)));
}
export { $isArrayOf_Lmealorama_StoreCartSearch as $isArrayOf_Lmealorama_StoreCartSearch };
var $d_Lmealorama_StoreCartSearch = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_StoreCartSearch, "mealorama.StoreCartSearch", ({
  k2: 1,
  bB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_StoreCartSearch as $d_Lmealorama_StoreCartSearch };
//# sourceMappingURL=mealorama.-Store-Cart-Search.js.map
